<daypilot-calendar [config]="configDay" [events]="displayedOrders" #scheduler></daypilot-calendar>